import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import getters from './getters'
import user from './modules/user'
import suggestion from './modules/suggestion'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user, suggestion
  },
  getters,
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })]
})
